import { EDealRequestLinkType } from "../../../api/hooks/use-deal-request-exchange";
import { Dictionary } from "../../../lib/classes";

export enum EDealRequestType {
  Purchase = "Purchase",
  Sale = "Sale",
  DealService = "DealService",
  Other = "Other",
  Ransom = "Ransom",
  Estimate = "Estimate",
}

export enum EDealRequestStatus {
  Opened = "Opened",
  Active = "Active",
  Pending = "Pending",
  Cancelled = "Cancelled",
  Postponed = "Postponed",
  Closed = "Closed",
}

export enum EWallMaterial {
  Brick = "Brick",
  Monolith = "Monolith",
  BrickMonolith = "BrickMonolith",
  Panel = "Panel",
  Block = "Block",
  Wood = "Wood",
  Other = "Other",
}

export const DealRequestLinkType = new Dictionary<EDealRequestLinkType>([
  {
    key: EDealRequestLinkType.Swap,
    label: "Обмен",
  },
  {
    key: EDealRequestLinkType.TradeIn,
    label: "Трейд-ин",
  },
]);

export const DealRequestType = new Dictionary<EDealRequestType>([
  {
    key: EDealRequestType.Purchase,
    label: "Покупка",
  },
  {
    key: EDealRequestType.Sale,
    label: "Продажа",
  },
  {
    key: EDealRequestType.DealService,
    label: "Сервис сделки",
  },
  {
    key: EDealRequestType.Ransom,
    label: "Выкуп",
  },
  {
    key: EDealRequestType.Estimate,
    label: "Оценка",
  },
  {
    key: EDealRequestType.Other,
    label: "Остальные",
  },
]);

export const DealRequestStatus = new Dictionary<EDealRequestStatus>([
  {
    key: EDealRequestStatus.Active,
    label: "Активна",
  },
  {
    key: EDealRequestStatus.Cancelled,
    label: "Отменена",
  },
  {
    key: EDealRequestStatus.Closed,
    label: "Закрыта",
  },
  {
    key: EDealRequestStatus.Opened,
    label: "Открыта",
  },
  {
    key: EDealRequestStatus.Pending,
    label: "В процессе",
  },
  {
    key: EDealRequestStatus.Postponed,
    label: "Отложена",
  },
]);

export const WallMaterial = new Dictionary<EWallMaterial>([
  {
    key: EWallMaterial.Brick,
    label: "Кирпич",
  },
  {
    key: EWallMaterial.Monolith,
    label: "Монолит",
  },
  {
    key: EWallMaterial.BrickMonolith,
    label: "Кирпич-монолит",
  },
  {
    key: EWallMaterial.Panel,
    label: "Панель",
  },
  {
    key: EWallMaterial.Block,
    label: "Блок",
  },
  {
    key: EWallMaterial.Wood,
    label: "Дерево",
  },
  {
    key: EWallMaterial.Other,
    label: "Другие",
  },
]);
